<div id="paymentModal" class="modal">
  <div class="mainModal">
    <div class="modal-content">
      <div class="modalContent">
        <div class="giftPayment">
          <img src='assets/imgs/giftpayment.png' class='enroll-memb__img' />
        </div>
        <ng-container *ngIf="giftedMemberDetails; else buyMembership">
          <h3 class="membership">
            {{ giftedMemberDetails?.transactionNumber ? ('giftDetail.payment_title' | translate: giftedMemberDetails) : ('giftDetail.payment_title_without_transaction' | translate)}}
          </h3>
          <p class="membership-disc">{{'giftDetail.payment_para' | translate: giftedMemberDetails}}</p>
        </ng-container>
        <ng-template #buyMembership> 
          <ng-container *ngIf="transaction; else buyCertificate">
            <p class="membership-disc">
              {{ transaction?.transactionNumber ? ('buyAnotherMembership.new_membership' | translate: transaction) :
              ('buyAnotherMembership.new_membership_without_transaction' |translate)}}
            </p>
          </ng-container>
        </ng-template>
        <ng-template #buyCertificate> 
          <ng-container *ngIf="paymentSuccessDetails">
            <div class="feedback">
              <h3 class="membership">
                {{ paymentSuccessDetails?.transactionNumber ? ("buyCertificate.payment_success" | translate :
                paymentSuccessDetails) : ("buyCertificate.payment_success_without_transaction" | translate)}}
              </h3>
              <!-- <p class="membership-disc"> -->
              <p class="membership">
                {{"buyCertificate.payment_success_description" | translate: paymentSuccessDetails}} </p>
            </div>
          </ng-container>
        </ng-template>
      </div>
      <ng-container *ngIf="giftedMemberDetails; else buyMembershipButtons">
        <ion-button mode="ios" class="modalButton primary-gradient" expand="block" (click)="goToTabsFunc()">
          {{'dinningReservation.got_it' | translate}}
        </ion-button>
      </ng-container>
      <ng-template #buyMembershipButtons>
        <ng-container *ngIf="transaction; else buyCertificateButtons">
          <ion-button mode="ios" expand="block" class="modalButton primary-gradient" (click)="navigateToWallet()">
            {{'login.proceed' |translate}}
          </ion-button>
        </ng-container>
      </ng-template>
      <ng-template #buyCertificateButtons> 
        <ng-container *ngIf="paymentSuccessDetails">
          <ion-button mode="ios" expand="block" class="modalButton primary-gradient" (click)="navigateToHome()">
            {{"buyCertificate.payment_success_button" | translate}}
          </ion-button>
        </ng-container>
      </ng-template>
    </div>
  </div>
</div>